"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

type SubtleSpotlightProps = {
  children: React.ReactNode
  className?: string
  color?: string
}

// Minimal, theme-aware spotlight wrapper inspired by ReactBits Spotlight Card patterns
export function SubtleSpotlight({
  children,
  className,
  color = "hsl(var(--primary) / 0.08)",
}: SubtleSpotlightProps) {
  const ref = React.useRef<HTMLDivElement>(null)
  const [pos, setPos] = React.useState({ x: 0, y: 0 })
  const [opacity, setOpacity] = React.useState(0)

  function onMove(e: React.MouseEvent<HTMLDivElement>) {
    if (!ref.current) return
    const rect = ref.current.getBoundingClientRect()
    setPos({ x: e.clientX - rect.left, y: e.clientY - rect.top })
  }

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseEnter={() => setOpacity(1)}
      onMouseLeave={() => setOpacity(0)}
      className={cn("relative", className)}
    >
      <div
        className="pointer-events-none absolute inset-0 transition-opacity duration-300 ease-out"
        style={{
          opacity,
          background: `radial-gradient(400px circle at ${pos.x}px ${pos.y}px, ${color}, transparent 40%)`,
        }}
      />
      {children}
    </div>
  )
}

export default SubtleSpotlight
